import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Text,
  LegacyCard as Card,
  Collapsible,
  // Link,
  ProgressBar,
  SkeletonBodyText,
  InlineStack,
} from "@shopify/polaris";
import { PrivateContext } from "lib/context";
import { baseHelper } from "lib/helpers";
import { StyledCardHeader } from "asset/styles/globalStyle";
import { useQuery } from "@apollo/client";
import { GET_ALL_COUNTS } from "app/reports/apollo/queries/quickReportData";
import constant from "lib/constant/constant";
import { StyledPlanCard, InnerCard } from "app/plans/widgets/operator/features/planCard/planCardStyle";

const ProviderPlanCard = () => {
  const { cms, currentUser, isLoading } = useContext(PrivateContext);
  const [openPlanCard, setOpenPlanCard] = useState(true);
  const { gql } = constant;
  const [productCount, setProductCount] = useState(0);

  const { plan = {}, products = {} } = currentUser;
  const { code = "", commission, name = "", price = "" } = plan;
  const { max: maxProduct = "", used = 0 } = products || {};
  const planURL = "/update/plan";

  const { data: productCountData } = useQuery(GET_ALL_COUNTS);

  useEffect(() => {
    if (productCountData) {
      const countProduct = baseHelper.getResponseData(productCountData, gql.GET_COUNT);
      const { productCount: productCounts } = countProduct;
      setProductCount(productCounts.total);
    }
  }, [productCountData]);

  if (isLoading) {
    return <SkeletonBodyText lines={3} />;
  }

  return (
    <Card>
      <StyledPlanCard>
        <StyledCardHeader>
          <Card.Header title={cms("common.label.planCard.title")}>
            <Button
              variant="plain"
              disclosure={openPlanCard ? "up" : "down"}
              onClick={() => {
                setOpenPlanCard(!openPlanCard);
              }}
            >
              {openPlanCard ? cms("common.label.hide") : cms("common.label.show")}
            </Button>
          </Card.Header>
        </StyledCardHeader>
        <Collapsible
          open={openPlanCard}
          id="collapsiblePlanCard"
          transition={{ duration: "150ms", timingFunction: "ease" }}
        >
          <br />
          <Card>
            <InnerCard className="inner-card">
              <Card.Section subdued>
                <div className="stack-wrapper plan">
                  <InlineStack blockAlign="center">
                    <div>
                      <Text as="span" fontWeight="semibold">
                        {baseHelper.ucFirst(baseHelper.getPlanBadge(code || name))}
                      </Text>
                      <Text variant="bodySm" as="p">
                        <Text as="span" tone="subdued">
                          {cms("common.label.planCard.currentPlan")}
                        </Text>
                      </Text>
                    </div>
                    <Text variant="bodySm" as="p">{`${currentUser.moneyFormat}${price}/m`}</Text>
                  </InlineStack>
                </div>
                <div className="stack-wrapper count">
                  <InlineStack>
                    <Text as="span">{cms("common.label.tabs.operator.products")}</Text>
                    <Text as="span" tone="subdued">{`${productCount || 0}/${maxProduct}`}</Text>
                  </InlineStack>
                  <ProgressBar progress={((productCount || 0) / maxProduct) * 100} size="small" />
                </div>
                <div className="stack-wrapper count">
                  <InlineStack>
                    <Text as="span">{cms("common.label.commission")}</Text>
                    <Text as="span" tone="subdued">{`${commission}%`}</Text>
                  </InlineStack>
                </div>
                <div className="upgrade-button">
                  <Button variant="primary" fullWidth url={planURL}>
                    {cms("common.button.upgrade")}
                  </Button>
                </div>
              </Card.Section>
            </InnerCard>
          </Card>
        </Collapsible>
      </StyledPlanCard>
    </Card>
  );
};

export default ProviderPlanCard;
